import * as React from 'react';
import { Button } from './Button';
import { jsx as _jsx } from "react/jsx-runtime";
const IconButton = /*#__PURE__*/React.forwardRef(IconButton_withRef);
function IconButton_withRef({
  icon,
  children,
  ...extraProps
}, ref) {
  return /*#__PURE__*/_jsx(Button, {
    ref: ref,
    iconOnly: true,
    iconBefore: icon,
    ...extraProps,
    children: children
  });
}
IconButton.displayName = 'IconButton';
export { IconButton };